import React, { useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useSelector, useDispatch } from "react-redux";
import { getPageContents } from "../../../actions/admin/cmspage";
import { useLoading } from "../../../components/LoadingContext";
import { useTranslation } from "react-i18next";
import { cn } from "../../../utils/classnames";
import { createTypographyHelper } from "../../../utils/typography";
import GeneralCancellationPolicy from "../../../components/cancellation-policy/general/cancellation-policy";
import BusinessCancellationPolicy from "../../../components/cancellation-policy/business/cancellation-policy";
import BusinessSamedayReschedulePolicy from "../../../components/cancellation-policy/business/same-day";
import BusinessMeetAssistCancellationPolicy from "../../../components/cancellation-policy/business/meet-assist";

const HiddenCancellationPolicy = () => {
  const page_name = "cms-cancellation-policy";
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage, loading } = cmspage_state;
  const lang = i18n.language?.toUpperCase();
  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);
  const { showLoading, closeLoading } = useLoading();
  const getTypographyClass = createTypographyHelper(i18n.language);

  return (
    <FrontLayout>
      {loading ? showLoading(true) : closeLoading(true)}
      <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
        <div className="tw:bg-[linear-gradient(37.52deg,rgba(33,37,41,0.5)_7.63%,rgba(33,37,41,0.25)_29.62%)] tw:lg:bg-[linear-gradient(87.06deg,#000000_6.43%,rgba(40,42,45,0.3)_46.3%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0"></div>
        <img
          src={lang === "EN" ? cmspage?.page_content_en.image1 : cmspage?.page_content_jp.image1}
          alt="Our fleet banner"
          className="tw:w-full tw:h-[430px] tw:object-cover"
        />
        <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
          <div className="tw:text-[rgba(219,190,120,1)] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
            {lang === "EN" ? cmspage?.page_content_en.content1 : cmspage?.page_content_jp.content1}
          </div>
          <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal tw:capitalize">
            {lang === "EN" ? cmspage?.page_content_en.content2 : cmspage?.page_content_jp.content2}
          </div>
        </div>
      </div>

      <p className="tw:block tw:md:hidden tw:text-center tw:italic tw:!text-[#7C7B7B] tw:!mt-6 tw:mb-0 tw:px-3 tw:!text-[14px]">
        {lang === "EN" ? cmspage?.page_content_en.content3 : cmspage?.page_content_jp.content3}
      </p>
      <BusinessCancellationPolicy
        className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:mt-6 tw:lg:pt-6 tw:px-0"
      />
      <BusinessSamedayReschedulePolicy
        className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:mt-12 tw:lg:pt-1 tw:px-0"
      />
      <BusinessMeetAssistCancellationPolicy
        className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:mt-12 tw:lg:pt-1 tw:pb-12 tw:px-0"
      />
    </FrontLayout>
  );
};

export default HiddenCancellationPolicy;
